import {getSelectItemLabel} from '~/components/Controls/Select';
import {IModel} from '~/lib/model';

export enum AdType {
    MREC = 'mrec',
    BANNER = 'banner',
    INTERSTITIAL = 'interstitial',
    NATIVE = 'native',
    SKIPPABLE_VIDEO = 'skippable_video',
    NON_SKIPPABLE_VIDEO = 'non_skippable_video',
    NON_SKIPPABLE_INTERSTITIAL = 'non_skippable_interstitial'
}

export const adTypes: { value: AdType; label: string }[] = [
    {value: AdType.MREC, label: 'Mrec'},
    {value: AdType.BANNER, label: 'Banner'},
    {value: AdType.INTERSTITIAL, label: 'Interstitial'},
    {value: AdType.NATIVE, label: 'Native'},
    {value: AdType.SKIPPABLE_VIDEO, label: 'Skippable Video'},
    {value: AdType.NON_SKIPPABLE_VIDEO, label: 'Non Skippable Video'},
    {value: AdType.NON_SKIPPABLE_INTERSTITIAL, label: 'Non Skippable Interstitial'}
];

export const getAdTypeLabel = (adType: AdType) => getSelectItemLabel(adTypes, adType);

export interface ICreative extends IModel {
    adCategory: AdType;
    adDomain: string;
    agencyId: number;
    agencyName: string;
    cid: string;
    crid: string;
    hash: string;
    iURL: string;
    updated?: string;
    adm?: string;
    categories?: string;
    bundle?: string;
}

